module.exports = __webpack_public_path__ + "static/media/video.372184c0.svg";